import { Link } from "wouter";
import { ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/use-auth";
export default function UnauthorizedPage() {
  const { user } = useAuth();
  const homeLink =
    user?.role === "admin"
      ? "/admin/dashboard"
      : user?.workspaceRole === "workspace_admin"
        ? "/dashboard"
        : "/assessments";

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#001F24] to-[#009687] flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-2xl p-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="rounded-full bg-red-100 p-6">
            <ShieldAlert className="h-16 w-16 text-red-600" />
          </div>
        </div>

        <h1 className="text-3xl font-bold text-[#001F24] mb-4">
          {"Access Denied"}
        </h1>

        <p className="text-gray-600 mb-6">
          {"You don't have permission to access this page. This area is restricted to users with specific roles."}
        </p>

        <div className="flex flex-col gap-3">
          <Link href={homeLink}>
            <Button className="w-full bg-[#00444C] hover:bg-[#003038]">
              {"Go to Home"}
            </Button>
          </Link>

          {user?.role === "admin" && (
            <p className="text-sm text-gray-500 mt-2">
              {"Platform administrators should use the /admin/* routes to access system-wide features."}
            </p>
          )}

          {user?.role !== "admin" && user?.workspaceRole !== "workspace_admin" && (
            <p className="text-sm text-gray-500 mt-2">
              {"Members have limited access. Contact your workspace administrator for additional permissions."}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
